export const STORYLY_SUPPORTED_PAGES = {
    HOMEPAGE: 'homePage',
};

export const CONTAINER_ID = 'stories-container';

export const DESKTOP_STORIES_CAROUSEL_CONTAINERS = {
    [STORYLY_SUPPORTED_PAGES.HOMEPAGE]: '#hidden-markets-container',
};

export const MOBILE_STORIES_CAROUSEL_CONTAINERS = {
    [STORYLY_SUPPORTED_PAGES.FOOTBALL_MAIN_PAGE]: '.banners-container',
    [STORYLY_SUPPORTED_PAGES.HOMEPAGE]: '#hidden-markets-container',
};

export const DESKTOP_TITLE = 'Our home of content & opinions';
export const DESKTOP_DESC =  'Expert tips, big event previews and analysis, polls, quizzes and more... ';